import React, { useEffect, useContext } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import routes from "./../../config/app-route.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import UnauthorizeRoute from "../../config/Unauthorize-app-route.jsx";
import { isAuthenticated } from "./axiosConfig.js";

function setTitle(path, routeArray) {
  let appTitle;
  for (let i = 0; i < routeArray.length; i++) {
    if (routeArray[i].path === path) {
      appTitle = "SSF Fishing | " + routeArray[i].title;
    }
  }
  document.title = appTitle ? appTitle : "SSF Fishing";
}

const Content = ({ history }) => {
  const appSettings = useContext(AppSettings);

  useEffect(() => {
    setTitle(history.location.pathname, routes);
    const unListen = history.listen(() => {
      setTitle(history.location.pathname, routes);
    });
    return () => unListen();
  }, [history]);

  const isUserAuthenticated = isAuthenticated();

  return (
    <div className={"app-content " + appSettings.appContentClass}>
      <Switch>
        {isUserAuthenticated
          ? routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            ))
          : UnauthorizeRoute.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            ))}
      </Switch>
    </div>
  );
};

export default withRouter(Content);
